import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CustomizationPage from "@/pages/CustomizationPage";
import ContactPage from "@/pages/ContactPage";
import CataloguePage from "@/pages/CataloguePage";
import CollectionsPage from "@/pages/CollectionsPage";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
  return (
    <div className="grain-overlay">
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/personnalisation" element={<CustomizationPage />} />
            <Route path="/catalogue" element={<CataloguePage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
